import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface EmptyStateProps {
  onGenerate: () => void;
  isGenerating: boolean;
  mealType?: 'lunch' | 'dinner';
}

export function EmptyState({ onGenerate, isGenerating, mealType = 'dinner' }: EmptyStateProps) {
  const isMobile = useIsMobile();

  return (
    <Card className="text-center py-8 md:py-12">
      <CardContent className="px-4 md:px-6">
        <Sparkles className="h-12 w-12 md:h-16 md:w-16 text-muted-foreground mx-auto mb-4" />
        <h3 className="text-lg md:text-xl font-semibold mb-2">No {mealType} suggestions yet</h3>
        <p className="text-sm md:text-base text-muted-foreground mb-6">
          Generate AI-powered {mealType} suggestions for available dates based on your family's eating habits and preferences.
        </p>
        <Button 
          onClick={onGenerate} 
          disabled={isGenerating} 
          size={isMobile ? "default" : "lg"}
          className={isMobile ? "w-full" : ""}
        >
          <Sparkles className="h-4 w-4 mr-2" />
          Generate Meal Suggestions
        </Button>
      </CardContent>
    </Card>
  );
}